<!-- =========================================================================================
  File Name: ArchiveAdd.vue
  Description: Archive Add Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-archive-add">

    <vx-card title="게시글 추가" class="mb-base" >
      <archive-add-form class="mt-4" />
    </vx-card>

  </div>
</template>

<script>
import ArchiveAddForm  from './ArchiveAddForm'

export default {
  components: {
    ArchiveAddForm
  },
  data () {
    return {
    }
  },
  watch: {
  },
  methods: {
  }
  
}

</script>
